module.exports = __webpack_public_path__ + "img/img2.d22df6ee.png";